/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  accounts: [],
  limit: 5,
};

const getters = {
  accounts: state => state.accounts,
  limit: state => state.limit,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/accounts/partner/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response.data.data);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, accounts) {
    state.accounts = accounts;
  },
  [mTypes.EDIT_DATA](state, updatedAccount) {
    const index = state.accounts.findIndex(obj => obj.id === updatedAccount.id);
    if (index !== -1) {
      state.accounts[index] = updatedAccount;
    } else {
      state.accounts.unshift(updatedAccount);
    }
  },
  [mTypes.REMOVE_DATA](state, accountId) {
    const index = state.accounts.findIndex(obj => obj.id === accountId);
    state.accounts.splice(index, 1);
    state.accounts.totalCount -= 1;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};




// WEBPACK FOOTER //
// ./src/store/modules/accounts/accounts.js